import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcedureViewStore = defineStore('procedureView', () => {
    const needOfferPrice = ref(false);

    function setNeedOfferPrice(value) {
        needOfferPrice.value = value;
    }

    return {
        needOfferPrice,
        setNeedOfferPrice
    }
});
